module.exports = __webpack_public_path__ + "img/arrow-down.8f62ee34.svg";